module.exports = __webpack_public_path__ + "img/bg_r.6b9ae7ab.png";